<template>
  <div>
    <b-card :header="caption">
      <b-link :to="{name: 'service-create'}">
        <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
          创建服务
        </b-button>
      </b-link>
      <b-table ref="serviceTb" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" >
        <template #cell(type)="row">
          {{getType(row.item.type)}}
        </template>
        <template #cell(acl_token)="row">
          <template v-if="row.item.showToken">
            <template v-if="row.item.editToken">
              <b-form-input class="edit-token" type="text" v-model="row.item.tmp_acl_token" />
              <span @click="saveToken(row.index)"><i class="fa fa-check text-success" /></span>
              <span @click="cancelSave(row.index)"><i class="fa fa-close text-danger" /></span>
            </template>
            <template v-else @click="changeToken(row.index)">
              <span @click="changeToken(row.index)">{{ row.item.acl_token }}</span>
              <span @click="copyToken(row.index)"><i class="fa fa-copy text-success" /></span>
              <span @click="changeEdit(row.index)"><i class="fa fa-edit text-warning" /></span>
            </template>
          </template>
          <template v-else>
            <span @click="changeToken(row.index)">**********</span>
          </template>
        </template>
        <template #cell(app)="row">
          <b-link :to="{name: 'service-update', params: {serviceCode: row.item.code}}">
            <b-button size="sm" class="mr-2" variant="outline-warning">
              <span class="fa fa-edit" /> 编辑服务
            </b-button>
          </b-link>
          <b-link :to="{name: 'template-edit', params: {serviceCode: row.item.code}}">
            <b-button size="sm" class="mr-2" variant="outline-warning">
              <span class="fa fa-edit" /> 描述模板
            </b-button>
          </b-link>
          <b-link :to="{name: 'app-list', params: {serviceCode: row.item.code}}">
            <b-button size="sm" class="mr-2" variant="outline-primary">
              <span class="fa fa-list-ul" /> 实例列表
            </b-button>
          </b-link>
          <b-link :to="{name: 'app-create', params: {serviceCode: row.item.code}}">
            <b-button v-if="row.item.type==='auto'" size="sm" class="mr-2" variant="outline-success">
              <span class="fa fa-plus" /> 创建实例
            </b-button>
          </b-link>
<!--          <b-link :to="{name: 'demo-list', params: {serviceCode: row.item.code}}">-->
<!--            <b-button size="sm" class="mr-2" variant="outline-danger">-->
<!--              <span class="fa fa-book" /> 样例管理-->
<!--            </b-button>-->
<!--          </b-link>-->
          <b-button size="sm" class="mr-2" variant="outline-danger" @click="deleteService(row.index)">
            <span class="fa fa-trash-o" /> 删除
          </b-button>
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="<<" next-text=">>" @change="changePage" hide-goto-end-buttons/>
      </nav>
    </b-card>
    <TipModal ref="tip" :tipData="tipData">
      <template v-slot:footer>
        <b-button size="sm" variant="outline-dark" @click="cancelDelete()" >取消</b-button>
        <b-button size="sm" variant="outline-danger" @click="delService()" >删除</b-button>
      </template>
    </TipModal>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import utils from '@/utils/utils'
import api from '@/utils/api'
import consts from '@/utils/consts'
import TipModal from '@/components/TipModal'

export default {
  name: 'service',
  mixins: [Error],
  props: {
    caption: {
      type: String,
      default: '服务'
    }
  },
  components: {TipModal},
  data: () => {
    return {
      items: [],
      fields: consts.SERVICE_FIELDS,
      currentPage: 1,
      perPage: consts.DEFAULT_PER_PAGE,
      totalRows: 0,
      tipData: {
        data: null,
        title: '',
        msg: '',
        headerBgVariant: '',
        headerTextVariant: ''
      },
      firstSave: true
    }
  },
  created () {
    if (this.firstSave && this.$route.params.save) {
      this.totalRows = sessionStorage.getItem('serviceRow')
      this.currentPage = sessionStorage.getItem('servicePage')
      this.firstSave = false
    }
    this.changePage(this.currentPage)
  },
  beforeDestroy () {
    sessionStorage.setItem('serviceRow', this.totalRows)
    sessionStorage.setItem('servicePage', this.currentPage)
  },
  methods: {
    changePage (page) {
      this.currentPage = page
      api.fetchListData(this, api.getServiceList(), 'services', null, this.fetchCallback)
    },
    fetchCallback (resData) {
      this.items = resData['services']
      this.totalRows = resData['total_num']
      for (let idx in this.items) {
        this.items[idx].tmp_acl_token = this.items[idx].acl_token
        this.items[idx].showToken = false
        this.items[idx].editToken = false
      }
    },
    getType (type) {
      return utils.findInArray(consts.SERVICE_TYPES, type, 'text')
    },
    deleteService (idx) {
      this.tipData = {
        data: {id: this.items[idx]._id},
        title: '警告',
        msg: '是否确定删除服务【' + this.items[idx].name + '】？',
        headerBgVariant: 'danger',
        headerTextVariant: 'light'
      }
      this.$refs.tip.modalShow()
    },
    delService () {
      api.deleteData(this, api.getServiceDelete(this.$refs.tip.modalData.data.id), null, this.delCallback)
    },
    delCallback () {
      this.$refs.tip.modalHide()
      this.changePage(this.currentPage)
    },
    cancelDelete () {
      this.$refs.tip.modalHide()
    },
    changeToken (idx) {
      this.items[idx].showToken = !this.items[idx].showToken
      this.$refs.serviceTb.refresh()
    },
    copyToken (idx) {
      this.$copyText(this.items[idx].acl_token).then(e => {
        this.$message.info('已复制到剪贴板')
      }, function (e) {
        this.$message.error('复制失败')
      })
    },
    changeEdit (idx) {
      this.items[idx].editToken = true
      this.$refs.serviceTb.refresh()
    },
    saveToken (idx) {
      if (!this.items[idx].tmp_acl_token) {
        this.$message.warning('密钥不能为空')
        return
      }
      api.updateData(this, api.getServiceTokenChange(this.items[idx].code), {acl_token: this.items[idx].tmp_acl_token})
      this.$nextTick(() => {
        this.items[idx].acl_token = this.items[idx].tmp_acl_token
        this.items[idx].editToken = false
        this.$refs.serviceTb.refresh()
      })
    },
    cancelSave (idx) {
      this.items[idx].editToken = false
      this.items[idx].tmp_acl_token = this.items[idx].acl_token
      this.$refs.serviceTb.refresh()
    }
  }
}
</script>

<style>
  .edit-token {
    width: 85% !important;
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// Service.vue?70137f92